import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import features from 'lib/common/features';

class ExpirationTimer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       * Should we display the component?
       */
      enabled: false,

      /**
       * Seconds remaining
       */
      secondsRemaining: 0,

      /**
       * The formatted seconds into minutes/seconds
       */
      formattedTimeRemaining: false
    };

    this.countdown = this.countdown.bind(this);
  }

  componentDidMount() {
    if (this.props.cart && !this.state.enabled) {
      let now = Date.now();
      let expirationDate = this.getExpirationTime(
        get(this.props.cart, 'Order.first_seat_added_dt')
      );
      let secondsRemaining = Math.floor((expirationDate - now) / 1000);
      this.setState({
        enabled: true,
        secondsRemaining: secondsRemaining
      });

      this.interval = setInterval(this.countdown, 1000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  formatTimeRemaining() {
    let secondsRemaining = this.state.secondsRemaining;
    let minutes = Math.floor(secondsRemaining / 60);
    let seconds = secondsRemaining - minutes * 60;

    return `${minutes} minutes and ${seconds} seconds`;
  }

  countdown() {
    // Format the date
    this.setState({
      secondsRemaining: this.state.secondsRemaining - 1,
      formattedTimeRemaining: this.formatTimeRemaining()
    });
    if (this.state.secondsRemaining < 1) {
      // The cart has expires
      clearInterval(this.interval);
      window.location = features.getOption('expirationTimer', 'redirect');
    }
  }

  getExpirationTime(firstSeatAddedAt) {
    // Create a date from what we get
    firstSeatAddedAt = new Date(firstSeatAddedAt);
    return (
      firstSeatAddedAt.getTime() +
      features.getOption('expirationTimer', 'timeoutLength')
    );
  }

  render() {
    if (!features.isEnabled('expirationTimer') || !this.state.enabled) {
      return null;
    }

    return (
      <div className="syos-expiration__timer">
        <p>Your cart will expire in {this.state.formattedTimeRemaining}</p>
      </div>
    );
  }
}

ExpirationTimer.propTypes = {
  cart: PropTypes.object
};

export default ExpirationTimer;



// WEBPACK FOOTER //
// ./src/javascripts/components/ExpirationTimer.js